import { Card } from "../../../../components";
import { Row } from "../../../../components/row";
import { LucideIcon } from "lucide-react";

interface SummaryCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  badgeText?: string;
  icon: LucideIcon;
  titleColor?: string;
  valueColor?: string;
  bgFrom?: string;
  bgTo?: string;
  borderColor?: string;
  iconColor?: string;
  iconBgColor?: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  value,
  subtitle,
  badgeText,
  icon: Icon,
  titleColor = "#4A5565",
  valueColor = "#364153",
  bgFrom = "white",
  bgTo = "white",
  borderColor = "#E6E6E6",
  iconColor = "#00C49A",
  iconBgColor = "#F2FCFA",
}) => {
  return (
    <Card
      className={`p-4 border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-lg`}
    >
      <Row className="flex justify-between items-start">
        <span className="font-semibold text-sm text-gray-900 dark:text-gray-100">{title}</span>
        <div className="rounded-lg w-8 h-8 flex items-center justify-center bg-[#F2FCFA] dark:bg-emerald-900/30 dark:border-emerald-700">
          <Icon size={16} className="text-emerald-400 dark:text-emerald-400" />
        </div>
      </Row>

      <Row className="block mt-1">
        <span className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {value}
        </span>
        {subtitle && <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">{subtitle}</div>}

        {/* {badgeText && (
          <div className="mt-2">
            <span
              className="inline-flex items-center rounded-lg px-3 py-2 w-fit"
              style={{
                color,
                border: `1px solid ${color}`,
                backgroundImage: `linear-gradient(to left, ${bgFrom}, ${bgTo})`,
              }}
            >
              <Icon className="mr-2" size={16} color={color} />
              {badgeText}
            </span>
          </div>
        )} */}
      </Row>
    </Card>
  );
};

export default SummaryCard;
